import React, { useCallback, useEffect, useState } from 'react';

import './Slider.scss'

export function TimeSlider({
    inMotion, startTimestamp, startPassedTime,
    duration, setNewPassedTime, updatePassedTimeForAnotherView }) {
    const [passedTime, _setPassedTime] = useState(Math.min(startPassedTime + ((new Date()).getTime() - startTimestamp) / 1000, duration));
    const setPassedTime = useCallback((p) => {
        const p2 = Math.round(p);
        _setPassedTime(p2);
        if (updatePassedTimeForAnotherView)
            updatePassedTimeForAnotherView(p2);
    }, [updatePassedTimeForAnotherView]);
    const progressIStr = String(100 - ((passedTime) / (duration) * 100));
    const backgroundStr =
        "linear-gradient(to left, " +
        "rgba(255, 255, 255, 0.35) 0%," +
        "rgba(255, 255, 255, 0.35) " + progressIStr + "%, " +
        "rgb(0, 255, 220) " + progressIStr + "%, " +
        "rgb(0, 255, 220) 100%)";

    useEffect(() => {
        setPassedTime(Math.min(startPassedTime + ((new Date()).getTime() - startTimestamp) / 1000, duration));

        if (inMotion) {
            const i = setInterval(() => {
                const t = startPassedTime + ((new Date()).getTime() - startTimestamp) / 1000;
                if (t > duration) {
                    setPassedTime(duration);
                    clearInterval(i);
                } else {
                    setPassedTime(t);
                }

            }, 1000);

            return () => { clearInterval(i) };
        }
    }, [inMotion, startTimestamp, startPassedTime, duration, setPassedTime]);

    return (
        <input type="range" min={0} max={duration}
            dir="ltr" // not necessary
            value={passedTime} onChange={(e) => setNewPassedTime(parseInt(e.target.value))}
            className="time-slider"
            style={{ backgroundImage: backgroundStr }}></input>
    )
}


export function SimpleSlider({ value, setValue, min, max }) {
    // const progressIStr = String(100 - value);  // [0, 100]
    const progressIStr = String(100 - ((value - min) / (max - min) * 100));
    const backgroundStr =
        "linear-gradient(to left, " +
        "rgba(255, 255, 255, 0.35) 0%," +
        "rgba(255, 255, 255, 0.35) " + progressIStr + "%, " +
        "rgb(0, 255, 220) " + progressIStr + "%, " +
        "rgb(0, 255, 220) 100%)";

    return (
        <input type="range" min={min} max={max}
            dir="ltr" // not necessary
            value={value} onChange={(e) => setValue(parseInt(e.target.value))}
            className="simple-slider"
            style={{ backgroundImage: backgroundStr }}></input>
    )
}